import * as yup from "yup";

export const validationSchema = yup.object().shape({
  lectureCode: yup.number().typeError("Meeting code must be number").required("Meeting Code is required."),
});

export const initValues = { lectureCode: "" };
